// StripeTestPanel.jsx
import React, { useState, useMemo, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { loadAuth, updatePlan } from "../libs/authMgmt";
import { getApiClient } from "../libs/axiosInstance";


const axios = getApiClient();

const stripePromise = loadStripe(
  process.env.REACT_APP_PUBLIC_STRIPE_PUBLISHABLE_KEY
);
const apiBase = process.env.REACT_APP_API_URL;

function toMinorUnits(amountNumber) {
  return Math.round(Number(amountNumber) * 100);
}

function CheckoutForm({ onPaid }) {
  const stripe = useStripe();
  const elements = useElements();
  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault();
        if (!stripe || !elements) return;
        const { error } = await stripe.confirmPayment({
          elements,
          confirmParams: { return_url: window.location.origin + "/pos/paid" },
        });
        if (error) alert(error.message);
        else onPaid?.();
      }}
    >
      <PaymentElement />
      <button disabled={!stripe} style={{ marginTop: 12 }}>
        Pay
      </button>
    </form>
  );
}

export default function StripeTestPanel({ priceIds = [] }) {
  const [busy, setBusy] = useState(false);
  const [posAmount, setPosAmount] = useState("129.00");
  const [clientSecret, setClientSecret] = useState(null);
  const [isOnboarded, setIsOnboarded] = useState(false);
  const [plan, setPlan] = useState("loading...");
  const [until, setUntil] = useState(null);
  const [error, setError] = useState(null);
  const [firstTimeOnboarding, setFirstTimeOnboarding] = useState(false);

  const [onboardedStateLoad, setOnboardedStateLoad] = useState(true);

  const subdomain = loadAuth("company")?.subdomain ?? "XXX";
  const CLIENT_CURRENCY = loadAuth("company")?.currency ?? "CAD";


  useEffect((_) => {
    async function fetchPlan() {
      try {
        const res = await axios.get("/api/companies/get-plan");
        const data = res.data;
        if (data.ok) {
          setPlan(data.plan || "free");
          updatePlan(data.plan || "free");
          setUntil(data.subscriptionUntil || null);
        } else {
          setError(data.error || "Could not fetch plan");
        }
      } catch (err) {
        console.error("Plan check failed:", err);
        setError(err.message);
      }
    }

    fetchPlan();
    async function as() {
      setOnboardedStateLoad(true)



      // const r = await getApiClient().get(
      //   `${apiBase}/api/companies/${subdomain}/stripe/connection-status`
      // );
      // const s = r.data;
      // setIsOnboarded(s.isReady); // if true, hide/disable "Connect Stripe"
      // setOnboardedStateLoad(false);
      try {
        const response = await axios.get(
          `${apiBase}/api/companies/${subdomain}/stripe/connection-status`
        );
        const data = response.data;
        setIsOnboarded(data.isReady); // if true, hide/disable "Connect Stripe"
      } catch (error) {
        console.error("Error fetching Stripe connection status:", error);
      } finally {
        setOnboardedStateLoad(false);
      }
    }
    as();
  }, []);

  const elementsOptions = useMemo(
    () => (clientSecret ? { clientSecret } : undefined),
    [clientSecret]
  );

  async function connectStripe() {
    setBusy(true);
    setFirstTimeOnboarding(true);
    // try {
    //   const r = await fetch(
    //     `${apiBase}/api/companies/${subdomain}/stripe/account-link`,
    //     {
    //       method: "POST",
    //     }
    //   );

    //   if (!r.ok) {
    //     const msg = await r.text(); // try to read server error
    //     throw new Error(`Server error (${r.status}): ${msg}`);
    //   }

    //   const data = await r.json();
    //   if (!data.url) {
    //     throw new Error("No onboarding URL returned from API");
    //   }

    //   window.location.href = data.url; // Stripe onboarding
    // } catch (err) {
    //   console.error("Failed to start Stripe onboarding:", err);
    //   alert(`Failed to connect Stripe: ${err.message}`);
    // }

    // setFirstTimeOnboarding(false);
    try {
      const response = await axios.post(
        `${apiBase}/api/companies/${subdomain}/stripe/account-link`
      );
    
      const data = response.data;
      if (!data.url) {
        throw new Error("No onboarding URL returned from API");
      }
    
      window.location.href = data.url; // Stripe onboarding
    } catch (err) {
      console.error("Failed to start Stripe onboarding:", err);
      alert(`Failed to connect Stripe: ${err.message}`);
    } finally {
      setFirstTimeOnboarding(false);
      setBusy(false);
    }
  }

  async function upgradePlan(priceId) {
    setBusy(true);
    try {
      const r = await getApiClient().post(
        `/api/companies/${subdomain}/billing/checkout`,
        {
          priceId
        }
      );

      const data = r.data;

      if (!data.url) {
        throw new Error("No checkout URL returned");
      }

      window.location.href = data.url;
    } catch (err) {
      console.error("Checkout error:", err);
      alert(`Failed to start checkout: ${err.message}`);
    }
  }

  async function startPosPayment() {
    setBusy(true);
    setClientSecret(null);
    const minor = toMinorUnits(posAmount);

    const r = await fetch(
      `${apiBase}/api/companies/${subdomain}/payments/create-intent`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amount: minor,
          currency: CLIENT_CURRENCY,
          orderId: "ORDER-TEST-001",
        }),
      }
    );
    const j = await r.json();
    setClientSecret(j.clientSecret);
    setBusy(false);
  }

  const currentPlan = loadAuth("company")?.plan;

  return (
    <div style={{ maxWidth: 500 }} className="stipe_cont">
      <div>
      <div style={{ display: "none", margin: "12px 0" }} className="input-group mb-3">
        <input
          style={{
            width: "50%",
            fontWeight: "400",
            fontSize: "16px",
            lineHeight: " 100%",
            letterSpacing: "0%",
            padding: "8px 12px",
            border: "1px solid #ccc",
            borderRadius: "6px",
          }}
          type="number"
          value={posAmount}
          onChange={(e) => setPosAmount(e.target.value)}
        />
        <button
          onClick={startPosPayment}
          disabled={busy}
          style={{
            border: "1px solid #ccc",
          }}
        >
          POS payment
        </button>
      </div>
      {clientSecret && (
        <Elements stripe={stripePromise} options={elementsOptions}>
          <CheckoutForm onPaid={() => setClientSecret(null)} />
        </Elements>
      )}
        <label>Stripe Integration</label> 
        <div className="alert alert-info">
          For accepting card payments and for your payouts
        </div>
      <div
        style={{ display: "none", background: "#ffeeba", padding: "8px", textAlign: "center" }}
      >
        If you recently upgraded/downgraded and your subscription status may be
        out of date, please <b>log out and log in again</b> to refresh your
        plan.
      </div>
      <button
        style={{
          marginTop: "2vh",
        }}
        onClick={connectStripe}
        disabled={busy || isOnboarded || firstTimeOnboarding || onboardedStateLoad}
        className="custom_button"
      >
        {isOnboarded ? "Already Connected" : firstTimeOnboarding ? "Connecting with Stripe..." : onboardedStateLoad ? "Fetching Data.." : "Connect Stripe"}
      
      
      </button>


      {error ? (
          <p style={{ color: "red" }}>{error}</p>
        ) : (
          <>
            <label className="d-block">Current Plan</label>
            <h3 className="text-capitalize">{plan}</h3>
            {until && <p>Valid Until: {new Date(until).toLocaleDateString()}</p>}
            {!until && plan !== "free" && (
              <p style={{ color: "orange" }}>
                Subscription period not synced. Please relogin if this looks wrong.
              </p>
            )}
          </>
        )}
      </div>

      <div className="d-flex">
        {
          isOnboarded === false ? <>To unlock premium plans and receive payments, please connect your Stripe account by clicking "Connect Stripe" above!</> : ""
        }
        {loadAuth("company")?.plan === "free" && isOnboarded ? (
          priceIds.map((priceId) => {
            return (
                <button
                className="custom_button me-2"
                  key={priceId.id}
                  disabled={busy}
                  onClick={(_) => upgradePlan(priceId.id)}
                >
                  Upgrade to {priceId.name}
                </button>
            );
          })
        ) : (
          currentPlan === "free" ? "" :
          <button
            key={priceIds.find(item => item.name.toLowerCase() === currentPlan.toLowerCase()).id}
            disabled={busy}
            onClick={(_) => upgradePlan(priceIds.find(item => item.name.toLowerCase() === currentPlan.toLowerCase()).id)}
            className="custom_button"
          >
            Manage your Subscription
          </button>
        )}
      </div>
    </div>
  );
}
